import useLoader from './useLoader'
import Loader from './Loader'

export { useLoader }
export default Loader
